import { Link } from "wouter";

const HowItWorks = () => {
  const steps = [
    {
      icon: "euro-sign",
      title: "Pay Just €15",
      description:
        "Secure your surprise meal for a fixed price of €15, knowing you'll get a dining experience worth more.",
    },
    {
      icon: "map-marker-alt",
      title: "Book Your Surprise",
      description:
        "Choose from our curated selection of partner restaurants. Let us know about your dietary preferences.",
    },
    {
      icon: "utensils",
      title: "Enjoy Your Meal",
      description:
        "Show up at the restaurant and be delighted by a chef-selected surprise meal made just for you.",
    },
  ];

  return (
    <section className="bg-gray-50 py-16 transition-colors duration-200 dark:bg-gray-900">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-16 text-center">
          <h2 className="mb-4 font-serif text-3xl font-bold text-gray-800 dark:text-white">
            How SurpriseTable Works
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-gray-600 dark:text-gray-300">
            Discover a new way to dine out - with excitement, value, and curated
            experiences.
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-3">
          {steps.map((step, index) => (
            <div
              key={index}
              className="rounded-xl bg-white p-6 shadow-md transition-all hover:shadow-lg dark:bg-gray-800"
            >
              <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-primary/10">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-primary dark:text-primary-dark"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  {step.icon === "euro-sign" && (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M14.121 15.879A10 10 0 1120 12c0-2.219-.72-4.272-1.938-5.938M12 9V3m0 0L8 7m4-4v12"
                    />
                  )}
                  {step.icon === "map-marker-alt" && (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                    />
                  )}
                  {step.icon === "utensils" && (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"
                    />
                  )}
                </svg>
              </div>
              <h3 className="mb-3 text-xl font-bold text-gray-800 dark:text-white">
                {step.title}
              </h3>
              <p className="text-gray-600 dark:text-gray-300">
                {step.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <Link href="/explore" 
            className="inline-flex items-center font-medium text-primary hover:text-red-700 dark:text-primary-dark dark:hover:text-red-400">
            <span>Browse Available Surprises</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="ml-2 h-4 w-4"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
